import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Don't have an account yet? `}<a parentName="p" {...{
        "href": "https://studio.apollographql.com/signup?referrer=odyssey"
      }}>{`Create one now`}</a>{` and you're all set with the Free plan! Jump to the next step.`}</p>
    <p>{`If you already have an existing account in an organization on a different plan, you must have `}<em parentName="p">{`Graph Admin`}</em>{` or `}<em parentName="p">{`Org Admin`}</em>{` role to create graphs and follow along with the course.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      